import templateStr from 'text!./templates/ho-upgrade.html';

var ctrlId = 0;

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            upgradeExists: '=',
            upgradeYear: '=',
            label: '@'
        },
        controller: ['$scope', function ($scope) {
            $scope.ctrlId = 'HoUpgradeCtrl' + ctrlId++;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/directives/HOUpgrade.js
// module id = 2158
// module chunks = 0